import api from "./api";

function toParams({ page, pageSize, search, sortBy, sortOrder, ...rest } = {}) {
    const params = { ...rest };
    if (page) params.page = page;
    if (pageSize) params.page_size = pageSize;
    if (search) params.search = search;
    if (sortBy) params.sort_by = sortBy;
    if (sortOrder) params.sort_order = sortOrder;
    return params;
}

export const workOrdersService = {
    async list(query = {}) {
        const { data } = await api.get("/work-orders", { params: toParams(query) });
        return data;
    },
    async get(id) {
        const { data } = await api.get(`/work-orders/${id}`);
        return data;
    },
    async create(payload) {
        const { data } = await api.post("/work-orders", payload);
        return data;
    },
    async update(id, payload) {
        const { data } = await api.patch(`/work-orders/${id}`, payload);
        return data;
    },
    async remove(id) {
        await api.delete(`/work-orders/${id}`);
    },
    async accept(id) {
        const { data } = await api.post(`/work-orders/${id}/accept`);
        return data;
    },
    async send(id) {
        const { data } = await api.post(`/work-orders/${id}/send`);
        return data;
    },
    async reject(id, reason) {
        const { data } = await api.post(`/work-orders/${id}/reject`, { reason });
        return data;
    },
    async start(id) {
        const { data } = await api.post(`/work-orders/${id}/start`);
        return data;
    },
    async finish(id) {
        const { data } = await api.post(`/work-orders/${id}/finish`);
        return data;
    },
    async cancel(id, reason) {
        const { data } = await api.post(`/work-orders/${id}/cancel`, { reason });
        return data;
    },
    async addNote(id, text) {
        const { data } = await api.post(`/work-orders/${id}/notes`, { text });
        return data;
    },
    async addPhoto(id, payload) {
        // payload = { url, caption? }
        const { data } = await api.post(`/work-orders/${id}/photos`, payload);
        return data;
    },
    async meta() {
        const { data } = await api.get("/work-orders/meta");
        return data;
    },
};
